import { useEffect, useState } from "react";
import { isTauri } from "@/lib/is-tauri";

/**
 * Returns the running Tauri app version (e.g. "0.6.20260608120000"),
 * or null when not running in Tauri or before the async lookup
 * resolves. Used by Settings → Updates to show the user which build
 * they're on — important for self-diagnosis when an update is stuck.
 */
export function useAppVersion(): string | null {
  const [version, setVersion] = useState<string | null>(null);

  useEffect(() => {
    if (!isTauri()) return;
    let cancelled = false;
    void import("@tauri-apps/api/app")
      .then(({ getVersion }) => getVersion())
      .then((v) => {
        if (!cancelled) setVersion(v);
      })
      .catch(() => {
        // Plugin missing or denied — leave null; UI hides the line.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return version;
}
